import React from 'react';
import PropTypes from 'prop-types';

export default class DetailsViewManagerComponent extends React.Component {

  constructor(props) {
    super(props);

    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.state = {};
  }

  componentDidMount() {
    this.setTableVisibility(false);
  }

  setTableVisibility(visibility) {
    this.setState({ isDetailsVisible: visibility });
    this.props.setVisibility(visibility);
  }

  toggleVisibility() {
    this.setTableVisibility(!this.state.isDetailsVisible);
  }

  render() {
    return (
      <button
        className={`${this.state.isDetailsVisible ? 'active' : ''} els-btn els-btn-xs els-btn-link e2e-additional-info`}
        aria-controls={this.props.ariaControls}
        aria-expanded={`${this.state.isDetailsVisible}`}
        ref='button'
        onClick={this.toggleVisibility}>
        <svg className='els-btn-icon els-btn-icon-tiny'>
          <use xlinkHref={this.state.isDetailsVisible ? '#icon-chevron-up' : '#icon-chevron-down'} />
        </svg>
        <span>{this.props.title}</span>
      </button>
    );
  }
}

DetailsViewManagerComponent.propTypes = {
  title: PropTypes.string.isRequired,
  setVisibility: PropTypes.func.isRequired,
  ariaControls: PropTypes.string.isRequired,
};
